import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Row,
  Col,
} from "reactstrap";
import UploadBlock from "../../../components/common/UploadBlock";
import TextInput from "../../../components/common/FormsInput/FormInput";
import { locInit, locSchema } from "./../schema";
import { Formik, Form } from "formik";
import LoaderUI from "../../../components/common/loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig, imageExtension } from "../../../utils/constants";
import { validationMessage } from "../../../utils/validation";
toast.configure();

/**
 * @description component use for update/add location
 */
const LocationFormModal = ({
  title,
  showModel,
  _submit,
  _toggle,
  _detail,
  _update,
  disabled,
  lodder,
}) => {
  const [payload, setPlayload] = useState(locInit);
  const [avtar, setAvtar] = useState("");
  const [logo, setLogo] = useState("");
  useEffect(() => {
    setPlayload({
      ...locInit,
      email: _detail?.email,
      phone: _detail?.phone,
      name: _detail?.name,
      address: _detail?.address,
    });
  }, [_detail]);

  /**
   * @description method use to add operator
   * @param {object} params form params
   * @param {Instance} status form status/valiations err
   */
  const submitForm = (params, status) => {
    let body = new FormData();
    body.append("logo", logo);
    body.append("name", params.name);
    body.append("address", params.address);
    body.append("email", params.email.toLowerCase());
    body.append("phone", params.phone);
    _detail?._id
      ? _update(body, _detail?._id, (res) => {
          setAvtar("");
        })
      : _submit(body, (res) => {
          setAvtar("");
        });
  };

  /**
   * @description method use to check file type
   * @param {object}
   */
  const fileCheckImg = (obj) => {
    var fileExtension = imageExtension;
    if (obj) {
      if (!fileExtension.includes(obj.name.split(".").pop())) {
        return true;
      }
      return false;
    }
    return false;
  };

  /**
   * @description method use to show uploaded image
   * @param {object} event form event
   */
  const _handleFileUpload = (event) => {
    var result = fileCheckImg(event);
    if (!result) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        if (fileReader.readyState === 2) {
          setAvtar(fileReader.result);
        }
      };
      fileReader.readAsDataURL(event);
      setLogo(event);
    } else {
      toast.error(validationMessage.imageReq, toasterConfig);
    }
  };

  /**
   * @description method use to open/hide operator form modal
   */
  const toggle = () => {
    setAvtar("");
    setLogo("");
    _toggle();
  };

  return (
    <>
      <Modal isOpen={showModel} toggle={() => toggle()} backdrop="static">
        <Formik
          initialValues={payload}
          enableReinitialize
          validationSchema={locSchema}
          onSubmit={submitForm}
        >
          {(formik) => (
            <Form>
              <ModalHeader>
                {title}
                <Button color="link" onClick={() => toggle()}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                  >
                    <g data-name="Group 651" transform="translate(-1535 -134)">
                      <g
                        fill="#fff"
                        stroke="#000"
                        strokeWidth="2"
                        data-name="Ellipse 30"
                        opacity="0.3"
                        transform="translate(1535 134)"
                      >
                        <circle cx="17" cy="17" r="17" stroke="none"></circle>
                        <circle cx="17" cy="17" r="16" fill="none"></circle>
                      </g>
                      <path
                        d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                        data-name="Icon ionic-ios-close"
                        opacity="0.3"
                        transform="translate(1534.289 132.789)"
                      ></path>
                    </g>
                  </svg>
                </Button>
              </ModalHeader>
              <ModalBody>
                <FormGroup>
                  <label>Upload Image</label>

                  <UploadBlock
                    name={"work group"}
                    avtar={avtar}
                    detail={_detail}
                    handleFileUpload={(event) => _handleFileUpload(event)}
                  />
                </FormGroup>
                <Row>
                  <Col sm="12">
                    <TextInput
                      name="name"
                      placeholder="Enter name"
                      value={formik?.values?.name}
                      onChange={formik.handleChange}
                      isRequired={true}
                      label="Name"
                    />
                  </Col>
                  <Col sm="12">
                    <TextInput
                      name="address"
                      type="textarea"
                      placeholder="Enter Work Group address"
                      value={formik?.values?.address}
                      onChange={formik.handleChange}
                      isRequired={true}
                      label="Work Group Address"
                    />
                  </Col>
                  <Col sm="6">
                    <TextInput
                      name="email"
                      placeholder="Enter email address"
                      value={formik?.values?.email}
                      onChange={formik.handleChange}
                      isRequired={true}
                      label="Email Address"
                    />
                  </Col>
                  <Col sm="6">
                    <TextInput
                      name="phone"
					  type= "text"
                      placeholder="Enter phone number"
                      value={formik?.values?.phone}
                      onChange={(event) => {
                        const inputPhoneNumber = event.target.value.replace(
                          /\D/g,
                          ""
                        );
                        let formattedPhoneNumber = "";

                        if (inputPhoneNumber.length < 4) {
                          formattedPhoneNumber = `(${inputPhoneNumber}`;
                        } else if (inputPhoneNumber.length < 7) {
                          formattedPhoneNumber = `(${inputPhoneNumber.slice(
                            0,
                            3
                          )}) ${inputPhoneNumber.slice(3)}`;
                        } else {
                          formattedPhoneNumber = `(${inputPhoneNumber.slice(
                            0,
                            3
                          )}) ${inputPhoneNumber.slice(
                            3,
                            6
                          )}-${inputPhoneNumber.slice(6, 10)}`;
                        }

                        formik.setFieldValue("phone", formattedPhoneNumber);
                        formik.setFieldTouched("phone", true);
                      }}
                      isRequired={true}
                      label="Phone"
                    />
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="link"
                  onClick={() => toggle()}
                  className="cancel-btn"
                >
                  Cancel
                </Button>
                <Button type="submit" disabled={disabled} color="secondary">
                  {!_detail._id && "Submit"}
                  {_detail._id && "Update"}
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
      {lodder && <LoaderUI className="modal-overlay-level-1" overlay />}
    </>
  );
};

export default LocationFormModal;
